import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiClient } from '../config/api';
import Layout from './Layout';
import './Dashboard.css';

const Dashboard = () => {
  const navigate = useNavigate();
  const [stats, setStats] = useState({
    totalUsers: 0,
    totalAvatars: 0,
    planDetails: [],
    userDetails: []
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const token = localStorage.getItem('token');
      
      if (!token) {
        console.error('No token found');
        setLoading(false);
        return;
      }
      
      // Fetch dashboard summary from API endpoint: GET /admin/dashboard/summary
      const response = await apiClient.get('/admin/dashboard/summary', token);
      
      console.log('Dashboard API Response:', response);
      
      // Extract data from response
      // Expected structure:
      // {
      //   "status": true,
      //   "status_code": 200,
      //   "data": {
      //     "active_users": 6,
      //     "total_avatars": 3,
      //     "active_plans": 6
      //   },
      //   "error": null,
      //   "msg": "Admin dashboard summary retrieved"
      // }
      
      const data = response.data || response;
      
      // Extract values from response
      const totalUsers = data.active_users || data.total_users || data.users || 0;
      const totalAvatars = data.total_avatars || data.avatars || 0;
      const activePlans = data.active_plans || data.plans || 0;
      
      // Handle plan details if provided in response
      let planDetails = [];
      if (data.plan_details && Array.isArray(data.plan_details)) {
        planDetails = data.plan_details;
      } else if (data.plans && Array.isArray(data.plans)) {
        planDetails = data.plans;
      } else if (activePlans > 0) {
        // Fallback: show active plans count if no detailed breakdown
        planDetails = [{
          name: 'Active Plans',
          count: activePlans
        }];
      }
      
      console.log('Extracted stats:', { totalUsers, totalAvatars, activePlans, planDetails });
      
      setStats({
        totalUsers,
        totalAvatars,
        planDetails,
        userDetails: []
      });
    } catch (error) {
      console.error('Error fetching dashboard stats:', error);
      // Set default values on error
      setStats({
        totalUsers: 0,
        totalAvatars: 0,
        planDetails: [],
        userDetails: []
      });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Layout>
        <div className="dashboard-loading">Loading...</div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="dashboard">
        <h1>Dashboard</h1>
        <div className="stats-grid">
          <div className="stat-card clickable" onClick={() => navigate('/users')}>
            <div className="stat-content">
              <h3>Active Users</h3>
              <p className="stat-number">{stats.totalUsers}</p>
            </div>
          </div>
          <div className="stat-card clickable" onClick={() => navigate('/avatars')}>
            <div className="stat-content">
              <h3>Total Avatars</h3>
              <p className="stat-number">{stats.totalAvatars}</p>
            </div>
          </div>
          <div className="stat-card clickable" onClick={() => navigate('/plans')}>
            <div className="stat-content">
              <h3>Active Plans</h3>
              <p className="stat-number">{stats.planDetails.length > 0 ? stats.planDetails[0].count : 0}</p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Dashboard;

